import useTranslation from "@/hooks/useTranslation";
import styles from "./styles.module.less";

const ContentFooter: React.FC = () => {
  const { t } = useTranslation("explore");
  return (
    <div className={styles.footer}>
      {t("pubmed.content.built")}
      <a
        href="https://www.ncbi.nlm.nih.gov/books/NBK25501/"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.sub}
      >
        {t("pubmed.content.statement")}
      </a>
    </div>
  );
};

export default ContentFooter;
